import { render } from "./CertificatesPage.vue?vue&type=template&id=2392a057"
import script from "./CertificatesPage.vue?vue&type=script&lang=js"
export * from "./CertificatesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__